// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vgt-left-align.task-name {\n  padding: 0px;\n}\n.vgt-left-align.task-name > div {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  background: transparent;\n}\n.vgt-left-align.task-name > div input {\n  padding: 0px;\n  width: 100%;\n  height: 100%;\n  border: none;\n  outline: none;\n  height: 60px;\n  padding: 1rem;\n  background: transparent;\n}", ""]);
// Exports
module.exports = exports;
